// src/services/queryClient.js
import { QueryClient } from '@tanstack/react-query';

/**
 * Configure the React Query client with default options
 * 
 * @see https://tanstack.com/query/v4/docs/react/reference/QueryClient
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data considered fresh for 5 minutes by default
      staleTime: 5 * 60 * 1000,
      
      // Cache data for 30 minutes (after which unused data is garbage collected)
      cacheTime: 30 * 60 * 1000,
      
      // Retry failed queries once
      retry: 1,
      
      // Don't refetch when window regains focus by default
      // This can be overridden per query
      refetchOnWindowFocus: false,
      
      // Show error notifications when queries fail
      onError: (error) => {
        console.error('Query error:', error);
      }
    },
    mutations: {
      // Show error notifications when mutations fail
      onError: (error) => {
        console.error('Mutation error:', error);
      }
    }
  }
});

export default queryClient;